"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _default = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      boxShadow: '0px 1px 6px 0px rgba(0,0,0,0.2)',
      padding: '16px'
    }, theme.breakpoints.up('1024'), {
      padding: '24px'
    })
  };
}, {
  name: 'pds-card'
});

exports.default = _default;
